import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { PERMISSION_REFUELING_CARDS } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import Form from '../../components/FuelCards/Form';
import { URL_FUEL_CARDS } from '../../router/constants';

export const Route = createFileRoute('/_authenticated/fuel_cards/add')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_REFUELING_CARDS, ['create'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.add',
        suffix: 'menu.fuelCardsOverview',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AddFuelCardRoute,
});

function AddFuelCardRoute() {
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    navigate({ to: URL_FUEL_CARDS });
  }, [navigate]);

  return <Form id={null} customerId={null} handleClose={handleClose} />;
}
